import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Jätka ostuga püsikliendina

  <span style="color:#85c1dc;">**FI:**</span>
  Jatka ostoksia ON24-asiakkaana

  <span style="color:#85c1dc;">**RU:**</span>
  Продолжайте делать покупки как постоянный клиент
*/
/* @__NO_SIDE_EFFECTS__ */
const m1625 = msg(
  mf`Jätka ostuga püsikliendina`,
  mf`Jatka ostoksia ON24-asiakkaana`,
  mf`Продолжайте делать покупки как постоянный клиент`,
)

export { m1625 as 'w.basket.continue_as_client' }